<template>
  <div
    class="text-center"
    :class="{
      'flex flex-row items-center': action,
      'flex-row-reverse': isLeft,
      'opacity-50': isLeft && action,
    }"
    @touchend="onClick"
    @click="onClick"
  >
    <div class="btn relative" :style="btnStyles">
      <transition-group name="fade" tag="div">
        <img
          :key="1"
          class="img-1"
          v-show="!hit"
          :class="{ breathing: shouldBreath }"
          :src="circle1"
        />
        <img
          :key="2"
          class="img-2"
          v-show="!hit"
          :class="{ breathing: shouldBreath }"
          :src="circle2"
        />
        <img :key="3" class="img-3" v-show="!hit" :src="circle3" />
        <img :key="4" class="img-4" v-show="!hit" :src="circle4" />
      </transition-group>
      <transition-group name="fill" tag="div">
        <img :key="5" class="img-5" v-show="hit" :src="circleFill" />
      </transition-group>
      <span
        v-if="action"
        class="action instruction main-gradient"
        :class="{ 'secondary-gradient': isLeft }"
        :style="actionStyles"
      >
        {{ action }}
      </span>
    </div>
  </div>
</template>

<script>
import incein from '@/mixins/incein';
import breathing from '@/mixins/breathing';

import circle1 from '../../assets/stamp/circle-1.png';
import circle2 from '../../assets/stamp/circle-2.png';
import circle3 from '../../assets/stamp/circle-3.png';
import circle4 from '../../assets/stamp/circle-4.png';
import circleFill from '../../assets/stamp/circle-fill.png';

import circle1Incein from '../../assets/stamp/incein-circle-1.svg';
import circle2Incein from '../../assets/stamp/incein-circle-2.svg';
import circle3Incein from '../../assets/stamp/incein-circle-3.svg';
import circle4Incein from '../../assets/stamp/incein-circle-4.svg';
import circleFillIncein from '../../assets/stamp/incein-circle-fill.svg';

export default {
  name: 'FillButton',
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
    hit: Boolean,
    hitDuration: {
      type: Number,
      default: 3000,
    },
    action: String,
    isLeft: Boolean,
    offset: {
      type: Number,
      default: 45,
    },
  },
  mixins: [breathing, incein],
  mounted() {
    this.hitTimer = null;
  },
  beforeDestroy() {
    if (this.hitTimer) {
      clearTimeout(this.hitTimer);
    }
  },
  data: () => ({
    active: false,
  }),
  watch: {
    hit(nv, ov) {
      if (nv && !ov) {
        this.onHit();
      } else if (ov && !nv) {
        this.active = false;
      }
    },
  },
  methods: {
    onHit() {
      if (this.active) return;

      this.active = true;
      this.hitTimer = setTimeout(() => {
        this.$emit('active');
      }, this.hitDuration);
    },
    onClick() {
      this.active = true;
      this.$emit('click');
    },
  },
  computed: {
    circle1() {
      return this.isIncein ? circle1Incein : circle1;
    },
    circle2() {
      return this.isIncein ? circle2Incein : circle2;
    },
    circle3() {
      return this.isIncein ? circle3Incein : circle3;
    },
    circle4() {
      return this.isIncein ? circle4Incein : circle4;
    },
    circleFill() {
      return this.isIncein ? circleFillIncein : circleFill;
    },
    btnStyles() {
      if (this.isLeft) return { right: `${this.offset}px` };

      return { left: `${this.offset}px` };
    },
    actionStyles() {
      let offset = '-85%';
      const style = {};
      if (this.mini) {
        style.transform = 'scale(2.6)';
        offset = '-250%';
      }
      if (this.isLeft) return { ...style, left: offset };

      return { ...style, right: offset };
    },
  },
};
</script>

<style scoped lang="scss">
.btn > div {
  @apply relative flex mx-auto justify-center items-center;
  width: 140px;
  bottom: 20px;
  img {
    @apply absolute;
  }
}
.img-1 {
  width: 90%;
}
.img-2 {
  width: 85%;
}
.img-3 {
  width: 70%;
}
.img-4 {
  width: 43%;
}
.img-5 {
  width: 50%;
}
.fade-enter-active {
  transition: all 0.5s ease-in;
}
.fade-leave-active {
  transition: all 2.5s ease-out;
}
.fade-enter-to,
.fade-leave {
  transform: scale(1) rotate(0);
}
.fade-enter,
.fade-leave-to {
  transform: scale(0) rotate(-200deg);
}

.fill-enter-active {
  transition: all 1s ease-out;
}
.fill-leave-active {
  transition: all 0.3s ease-out;
}
.fill-enter-to,
.fill-leave {
  transform: scale(1);
}
.fill-enter,
.fill-leave-to {
  transform: scale(0);
}
.instruction {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25;
  color: rgb(206, 221, 229);
}
.action {
  position: absolute;
  top: calc(50% - 15px);
  transform: translateY(-50%);
}
</style>
